<script setup lang="ts">
import { type Province } from '@lib/shared';

// PROPS
defineProps({
    provinces: { type: Array<Province>, default: () => [] },
    disabled: { type: Boolean, default: false },
});

// MODEL
const model = defineModel<string | undefined>({ required: true });

// COMPOSABLES
const { tt } = useTypedI18n();
</script>

<template>
    <USelectMenu
        v-if="provinces.length > 0"
        v-model="model"
        :items="provinces"
        value-key="name"
        label-key="name"
        :search-input="{ placeholder: tt('common.searchPlaceholder') }"
    >
        <template #empty="{ searchTerm: query }">
            <span>{{ tt('common.searchNoResults', { query }) }}</span>
        </template>
    </USelectMenu>
    <UInput v-else v-model.trim="model" :disabled="disabled" />
</template>
